import { Text } from '@consumidor-positivo/aurora';
import './styles.scss';

type SelectOptionsProps = {
  options: { id: string | boolean; label: string }[];
  onSelect?: (option: { id: string | boolean; label: string }) => void;
  htmlType?: 'button' | 'submit' | 'reset';
};

export const SelectOptions = ({ options, onSelect, htmlType }: SelectOptionsProps) => {
  return (
    <div className="select-opions">
      {options?.map((option, index) => (
        <button key={index} type={htmlType} className="select-options__option" onClick={() => onSelect && onSelect(option)}>
          <Text variant="body-medium">{option.label}</Text>
        </button>
      ))}
    </div>
  );
};
